// src/components/UiFeedbackWidget/FeedbackFab.jsx
//
// Spec 20260925-ui-feedback §6.1 / AC-14, plan T1.26 (+ K-9). Tasks T050.
//
// Bottom-right, 48px. It shares the corner with BackToTopFab, so it reads BackToTopFab's
// own visibility rule (useBackToTopVisible — one rule, not a copy) and sits 72px higher
// while that FAB shows, and in its place when it does not. On phones it clears the
// MobileBottomNav and the iOS home indicator the same way BackToTopFab does.

import React from 'react';
import { Fab, Tooltip } from '@mui/material';
import { RateReviewOutlined as FeedbackIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

import { BOTTOM_NAV_HEIGHT } from '../MobileBottomNav';

/** Extra lift while BackToTopFab (48px + 24px gap) is visible. */
export const BACK_TO_TOP_LIFT = 72;

/** The FAB's `bottom` per breakpoint, in px strings, for the FAB and the panel above it. */
export function fabBottom(backToTopVisible) {
  const lift = backToTopVisible ? BACK_TO_TOP_LIFT : 0;
  return {
    xs: `calc(${BOTTOM_NAV_HEIGHT}px + env(safe-area-inset-bottom, 0px) + ${16 + lift}px)`,
    md: `${24 + lift}px`,
  };
}

export default function FeedbackFab({ onClick, open, backToTopVisible }) {
  const { t } = useTranslation();
  return (
    <Tooltip title={t('Ideas.uiFeedback.fab_label')} placement="left">
      <Fab
        data-ui-feedback-root
        data-testid="ui-feedback-fab"
        size="medium"
        color={open ? 'secondary' : 'primary'}
        aria-label={t('Ideas.uiFeedback.fab_label')}
        aria-expanded={open ? 'true' : 'false'}
        aria-haspopup="dialog"
        onClick={onClick}
        sx={{
          position: 'fixed',
          right: 16,
          bottom: fabBottom(backToTopVisible),
          zIndex: (theme) => theme.zIndex.speedDial,
          transition: 'bottom 150ms ease-out',
        }}
      >
        <FeedbackIcon />
      </Fab>
    </Tooltip>
  );
}
